import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, map, of } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { OtherService } from 'src/app/services/other.service';

@Component({
  selector: 'app-specialist-my-registration',
  templateUrl: './specialist-my-registration.component.html',
  styleUrls: ['./specialist-my-registration.component.css']
})
export class SpecialistMyRegistrationComponent {
  @ViewChild('detailsDialogTemplate') detailsDialogTemplate: TemplateRef<any>;

  searchKey = '';

  myRegistrations$ = this.accountService.myRegistrations({
    iSystemUser: this.otherService.specialistUser.iSystemUser,
    strSession: this.otherService.specialistUser.strSession
  }).pipe(
    map((response: string) => JSON.parse(response)),
    catchError(() => of(false)),
  );

  tankerProfile = null;

  constructor(
    private accountService: AccountService,
    private otherService: OtherService,
    private ngbModal: NgbModal,
  ) { }

  openDtailsDialog(tankerProfile) {
    this.tankerProfile = tankerProfile;
    this.ngbModal.open(this.detailsDialogTemplate, { scrollable: true, container: 'app-specialist-my-registration', modalDialogClass: 'details-dialog', centered: true, animation: false });
  }
}
